module.exports = __webpack_public_path__ + "static/media/regionalone_logo.cf2606f2.png";